import { styled, Typography } from "@mui/material";
import { Checkbox } from "@volt_developers/components";

import { TEST_IDS } from "constants/TestIds";

import type { CountryCode } from "models/CountryCode";
import type { ReactNode, SyntheticEvent } from "react";

export interface CountryLabelProps {
  id: CountryCode;
  label: ReactNode;
  isSelected: boolean;
  onChange: (event: SyntheticEvent) => void;
}

export function CountryLabel({
  id,
  label,
  isSelected,
  onChange,
}: CountryLabelProps) {
  const testId = TEST_IDS.getCheckbox(id);

  return (
    <Wrapper>
      <Checkbox
        id={testId}
        data-testid={testId}
        checked={isSelected}
        onChange={onChange}
        onClick={(event) => event.stopPropagation()}
      />
      <Typography variant="small" color="text.high">
        {label}
      </Typography>
    </Wrapper>
  );
}

const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1.5),
}));
